import { useCallback, useEffect, useState } from 'react';

interface UseGameModalResult {
  show?: boolean;
  onClose: () => void;
}

export const useGameModal = (error?: boolean): UseGameModalResult => {
  const [show, setShow] = useState<boolean>();

  const onClose = useCallback(() => {
    setShow(false);
  }, []);

  useEffect(() => {
    if (error) {
      setShow(true);
    }
  }, [error]);

  return {
    show,
    onClose,
  };
};
